import { ASSOCIATE_NOT_FOUND } from '@/utilities/constants/associate'

/**
 * Gets the displayName with fallback to firstName + lastName
 * @param {Object} staff - Staff object containing firstName, lastName, and optionally displayName
 * @returns {string} The display name with fallback
 */
export const getFullName = (staff) => {
    if (!staff || !staff?.firstName) return ASSOCIATE_NOT_FOUND;
    return staff.displayName && staff.displayName.trim() !== "" 
        ? staff.displayName 
        : `${staff.firstName} ${staff.lastName}`;
}

export const validateAssociateData = (row) => {
    const { staff } = row
    if(!staff || !staff?.firstName) return ASSOCIATE_NOT_FOUND
    return getFullName(staff);
}

export function generateDisplayName({ firstName, lastName, nickname = '', overrideDisplayName = false, displayName = '' }) {
    // If override is enabled and a custom display name exists, use it
    if (overrideDisplayName && displayName && displayName.trim().length > 0) {
        return displayName.trim();
    }

    // Generate dynamic display name
    if (nickname && nickname.trim()) {
        return `${firstName} "${nickname.trim()}" ${lastName}`;
    }

    return `${firstName} ${lastName}`;
}
